var map = {
	"./achievement.svg": 7624,
	"./education.svg": 7919,
	"./educations.jpg": 4784,
	"./interests.svg": 480,
	"./programming-skills.svg": 753,
	"./projects.svg": 4341,
	"./work-history.svg": 339
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5957;